import { css, styled } from 'styled-components';

const SuperNavItem = styled('a')(
  ({ theme }) => css`
    color: ${theme.colors.white};
    border-radius: 5rem;
    padding: 0.15rem 1rem;
    font-size: 0.875rem;
    text-decoration: none;
    cursor: pointer;
    font-family: ${theme.fonts.default};

    &:hover {
      background-color: ${theme.colors.hoverGray};
    }
  `
);

export default SuperNavItem;
